import React from 'react';
import Translation from '../../../containers/i18n/Translation';
import Spinner from '../../common/Spinner';

const RequestInProgress = () => (
  <div className="modal request-in-progress">
    <Spinner />
    <p><Translation section="common" label="requestInProgress" /></p>
  </div>
);

export default RequestInProgress;
